import React, { FunctionComponent, useEffect, useState } from "react";

import { useSelector } from "react-redux";
import { useI18n } from "../../hooks/useI18n";
import { useLoadIfEmpty } from "../../hooks/useLoadIfEmpty";
import { thunkFetchProductPriorities } from "../../store/tenants/actions";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectProps
} from "@material-ui/core";
import { AppState } from "../../store";
import { Priority } from "../../models/Product";

interface PrioritySelectProps extends Omit<SelectProps, "loading"> {
  label?: string;
  onSelected?: (value?: Priority) => void;
  onSelectedStrict?: (value: Priority) => void;
  variant?: "filled" | "outlined" | "standard";
  value?: number | "";
  error?: boolean;
}

export const PrioritySelect: FunctionComponent<PrioritySelectProps> = ({
  label,
  onSelected,
  onSelectedStrict,
  onChange,
  variant = "standard",
  value,
  error = false,
  ...props
}) => {
  const { t } = useI18n();
  const defaultLabel = label || t("common.formFields.priority");
  const priorities = useSelector<AppState, ReadonlyArray<Priority>>(
    s => s.tenants.productPriorites
  );

  const [state, setState] = useState<ReadonlyArray<Priority>>([]);

  useLoadIfEmpty(!priorities?.length, thunkFetchProductPriorities);

  const handleChange = (
    event: React.ChangeEvent<{ name?: string; value: unknown }>,
    child: React.ReactNode
  ) => {
    let val = state.find(x => x.id === event.target.value);
    if (onSelected) {
      onSelected(val);
    }
    if (onSelectedStrict) {
      if (val) {
        onSelectedStrict(val);
      }
    }
    if (onChange) {
      onChange(event, child);
    }
  };

  useEffect(() => {
    let filtered = priorities && priorities.length > 0 && priorities;

    if (filtered) {
      setState(filtered);
    }
  }, [priorities]);

  return (
    <FormControl variant={variant} className={props.className} error={error}>
      <InputLabel
        id="priority-select-label"
        style={
          variant === "outlined"
            ? {
                backgroundColor: "#fff",
                paddingLeft: "0.5rem",
                paddingRight: "0.5rem"
              }
            : undefined
        }
      >
        {defaultLabel}
      </InputLabel>
      <Select
        value={value}
        onChange={handleChange}
        labelId="priority-select-label"
        id="priority-select"
        autoWidth={true}
      >
        {onSelected ? <MenuItem key={""} value={""} /> : null}
        {state &&
          state.length > 0 &&
          state.map(x => (
            <MenuItem key={x.id} value={x.id}>
              {x.name}
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  );
};
